/**
 * DO NOT CHANGE MANUALLY
 * GENERATED using @find/config-forge-cli
 */

import type Config from './models';

export const config: Config = {
  "virtualQ": {
    "enabled": true,
    "widgetUrlByPage": {
      "hotels": {
        "default": {
          "mobile": "https://form.virtualq.tech/embed/IUd2rKIegu8httbxL-QiD/custom",
          "desktop": "https://form.virtualq.tech/embed/IUd2rKIegu8httbxL-QiD/custom"
        }
      },
      "offers": {
        "default": {
          "mobile": "https://form.virtualq.tech/embed/NCtzUYqHDhV8GzWaXNGib/custom",
          "desktop": "https://form.virtualq.tech/embed/NCtzUYqHDhV8GzWaXNGib/custom"
        }
      }
    }
  },
  "travelPeriod": {
    "period": [
      {
        "range": {
          "start": "01-01",
          "end": "03-01"
        },
        "arrival": {
          "start": "today",
          "offset": {
            "count": 5,
            "unit": "months"
          }
        },
        "return": {
          "start": "arrivalDate",
          "offset": {
            "count": 3,
            "unit": "months"
          }
        }
      },
      {
        "range": {
          "start": "03-01",
          "end": "05-01"
        },
        "arrival": {
          "start": "today",
          "offset": {
            "count": 3,
            "unit": "months"
          }
        },
        "return": {
          "start": "arrivalDate",
          "offset": {
            "count": 3,
            "unit": "months"
          }
        }
      },
      {
        "range": {
          "start": "05-01",
          "end": "11-01"
        },
        "arrival": {
          "start": "07-01",
          "offset": {
            "min": true,
            "count": 7,
            "unit": "days"
          }
        },
        "return": {
          "start": "arrivalDate",
          "offset": {
            "count": 2,
            "unit": "months"
          }
        }
      },
      {
        "range": {
          "start": "11-01",
          "end": "01-01"
        },
        "arrival": {
          "start": "06-01",
          "nextYear": true
        },
        "return": {
          "start": "arrivalDate",
          "offset": {
            "count": 6,
            "unit": "months"
          }
        }
      }
    ],
    "duration": {
      "ownArrival": {
        "min": 2,
        "max": 6
      },
      "packageTour": {
        "min": 4,
        "max": 7
      }
    },
    "durationNext": {
      "ownArrival": {
        "min": 7,
        "max": 7
      },
      "packageTour": {
        "min": 7,
        "max": 7
      }
    }
  },
  "topRegions": {
    "packageTour": [
      "destination-tr-side-und-alanya",
      "destination-es-mallorca",
      "destination-eg-hurghada-und-safaga",
      "destination-gr-kreta",
      "destination-tr-tuerkische-riviera",
      "destination-tr-antalya-und-belek",
      "destination-es-fuerteventura",
      "destination-es-gran-canaria",
      "destination-gr-rhodos",
      "destination-es-teneriffa"
    ],
    "ownArrival": [
      "destination-es-mallorca",
      "destination-tr-antalya-und-belek",
      "destination-tr-side-und-alanya",
      "destination-it-gardasee",
      "destination-at-salzburger-land",
      "destination-at-nordtirol",
      "destination-tr-halbinsel-bodrum",
      "destination-tr-tuerkische-aegaeis",
      "destination-at-zillertal",
      "country-tschechien"
    ]
  },
  "topHotels": {
    "packageTour": [
      "5772-giata",
      "62341-giata",
      "228562-giata",
      "295816-giata",
      "235779-giata",
      "122892-giata",
      "7184-giata",
      "26585-giata",
      "409249-giata",
      "239871-giata",
      "91078-giata",
      "228738-giata",
      "10870-giata",
      "21718-giata",
      "39071-giata",
      "33-giata",
      "240020-giata",
      "13508-giata",
      "22-giata",
      "284863-giata",
      "13488-giata",
      "401572-giata",
      "90671-giata",
      "432337-giata",
      "31089-giata",
      "34938-giata",
      "4908-giata",
      "12425-giata",
      "33208-giata",
      "4720-giata",
      "93121-giata",
      "229225-giata",
      "5721-giata",
      "99957-giata",
      "2601-giata",
      "10-giata",
      "4905-giata",
      "10888-giata",
      "42492-giata",
      "51902-giata",
      "102481-giata",
      "632778-giata",
      "411455-giata",
      "21-giata",
      "5722-giata",
      "203290-giata",
      "229480-giata",
      "537970-giata",
      "242899-giata",
      "432791-giata",
      "3140-giata",
      "245498-giata",
      "27889-giata",
      "2619-giata",
      "70520-giata",
      "4724-giata",
      "12865-giata",
      "2719-giata",
      "40038-giata",
      "18521-giata",
      "93124-giata",
      "28045-giata",
      "295485-giata",
      "411766-giata",
      "69039-giata",
      "40034-giata",
      "779-giata",
      "236286-giata",
      "6672-giata",
      "10871-giata",
      "53098-giata",
      "530723-giata",
      "135473-giata",
      "2595-giata",
      "770801-giata",
      "227755-giata",
      "261573-giata",
      "102822-giata",
      "4640-giata",
      "110545-giata",
      "4878-giata",
      "103057-giata",
      "4925-giata",
      "64964-giata",
      "53602-giata",
      "409279-giata",
      "100610-giata",
      "70278-giata",
      "86-giata",
      "7366-giata",
      "2610-giata",
      "13683-giata",
      "183127-giata",
      "4660-giata",
      "4719-giata",
      "101007-giata",
      "7800-giata",
      "409250-giata",
      "70518-giata",
      "3182-giata"
    ],
    "ownArrival": [
      "19394-giata",
      "73281-giata",
      "125714-giata",
      "53123-giata",
      "20315-giata",
      "78493-giata",
      "185349-giata",
      "432337-giata",
      "1174277-giata",
      "238668-giata",
      "431456-giata",
      "25517-giata",
      "25568-giata",
      "22245-giata",
      "561572-giata",
      "20656-giata",
      "295500-giata",
      "136625-giata",
      "240020-giata",
      "411140-giata",
      "16220-giata",
      "537970-giata",
      "28514-giata",
      "34938-giata",
      "33307-giata",
      "228738-giata",
      "632778-giata",
      "135417-giata",
      "228703-giata",
      "20407-giata",
      "359875-giata",
      "20079-giata",
      "51902-giata",
      "4365-giata",
      "239871-giata",
      "14078-giata",
      "24824-giata",
      "9374-giata",
      "39569-giata",
      "99874-giata",
      "3475-giata",
      "21243-giata",
      "69039-giata",
      "8504-giata",
      "551258-giata",
      "296527-giata",
      "284863-giata",
      "70157-giata",
      "8762-giata",
      "12892-giata",
      "33271-giata",
      "7447-giata",
      "15794-giata",
      "7254-giata",
      "70387-giata",
      "34013-giata",
      "8270-giata",
      "40034-giata",
      "24907-giata",
      "10975-giata",
      "14632-giata",
      "659154-giata",
      "261564-giata",
      "18167-giata",
      "15876-giata",
      "25895-giata",
      "36886-giata",
      "54719-giata",
      "260606-giata",
      "135473-giata",
      "29260-giata",
      "12487-giata",
      "32308-giata",
      "261584-giata",
      "233412-giata",
      "4908-giata",
      "391494-giata",
      "517280-giata",
      "19071-giata",
      "235779-giata",
      "4702-giata",
      "11880-giata",
      "17475-giata",
      "28066-giata",
      "18549-giata",
      "78826-giata",
      "574183-giata",
      "13030-giata",
      "53319-giata",
      "31326-giata",
      "12471-giata",
      "35098-giata",
      "973312-giata",
      "209940-giata",
      "122892-giata",
      "35761-giata",
      "240031-giata",
      "295816-giata",
      "4285-giata",
      "249991-giata"
    ]
  },
  "sorting": {
    "optionsByPage": {
      "hotels": [
        "bd4Desc",
        "salesAsc",
        "priceAsc",
        "ratingDesc",
        "categoryDesc"
      ],
      "offers": [
        "priceAsc",
        "durationDesc",
        "departureDateAsc"
      ]
    },
    "defaultByPage": {
      "hotels": "bd4Desc",
      "offers": "priceAsc"
    }
  },
  "service": {
    "hotels": {
      "phone": {
        "phone": "0043 1 2530037",
        "tablet": "0043 1 2530037",
        "desktop": "0043 1 2530037"
      },
      "multiRoomBooking": {
        "phone": "0043 1 2530037",
        "tablet": "0043 1 2530037",
        "desktop": "0043 1 2530037"
      }
    },
    "offers": {
      "phone": {
        "phone": "0043 1 2530037",
        "tablet": "0043 1 2530037",
        "desktop": "0043 1 2530037"
      },
      "multiRoomBooking": {
        "phone": "0043 1 2530037",
        "tablet": "0043 1 2530037",
        "desktop": "0043 1 2530037"
      }
    },
    "defaultOpeningHours": {
      "timeFrom": "09:00",
      "timeUntil": "22:00"
    }
  },
  "searchForm": {
    "travelTypeField": {
      "options": [
        {
          "type": "packageTour"
        },
        {
          "type": "ownArrival"
        }
      ]
    }
  },
  "priceTag": {
    "showDiscountTooltip": true
  },
  "offerBox": {
    "showTransfer": true,
    "tourOperatorImagesTabEnabled": true,
    "contactTabEnabled": false
  },
  "newsletterBanner": {
    "trackingSource": {
      "desktop": "aidu_at_hotellist_central_fullsize_desktop_bali",
      "mobile": "aidu_at_hotellist_central_fullsize_mobile_bali"
    }
  },
  "liveChat": {
    "enabled": false
  },
  "hotelDetails": {
    "promotionBadgesHidden": false,
    "roomTypeHidden": false,
    "reviewSource": "AllAma"
  },
  "googleMapsApiOptions": {
    "version": "weekly",
    "libraries": [
      "marker"
    ]
  },
  "global": {
    "pricePerPerson": false
  },
  "footer": {
    "links": [
      {
        "headline": "travelAndVacation",
        "id": "travel",
        "items": [
          {
            "label": "travelOffers",
            "url": "reiseangebote"
          },
          {
            "label": "travelDe",
            "url": "https://www.ab-in-den-urlaub.de",
            "addCurrentPath": true
          },
          {
            "label": "travelCh",
            "url": "https://www.ab-in-den-urlaub.ch",
            "addCurrentPath": true
          },
          {
            "label": "voucher",
            "url": "https://www.ab-in-den-urlaub.de/magazin/gutscheine/"
          },
          {
            "label": "travelAgency",
            "url": "https://www.ab-in-den-urlaub.de/magazin/reisebuero/"
          },
          {
            "label": "themeHotels",
            "url": "hotels/themenhotels"
          },
          {
            "label": "hotelChains",
            "url": "hotels/hotelketten"
          },
          {
            "label": "operatorTermsAndConditions",
            "url": "service/veranstalteragb",
            "masked": false
          }
        ]
      },
      {
        "headline": "infoAndHelp",
        "id": "info",
        "items": [
          {
            "label": "service",
            "url": "service"
          },
          {
            "label": "faq",
            "url": "service/faq",
            "masked": false
          },
          {
            "label": "glossary",
            "url": "glossar"
          },
          {
            "label": "tourOperator",
            "url": "veranstalter"
          },
          {
            "label": "accessibility",
            "url": "service/barrierefreiheit",
            "target": "_blank"
          }
        ]
      },
      {
        "headline": "company",
        "id": "company",
        "items": [
          {
            "label": "aboutUs",
            "url": "service/ueberuns"
          },
          {
            "label": "jobs",
            "url": "https://jobs.ab-in-den-urlaub.de/",
            "masked": false
          },
          {
            "label": "press",
            "url": "magazin/presse/"
          },
          {
            "label": "termsAndConditions",
            "url": "service/agb",
            "masked": false
          },
          {
            "label": "privacy",
            "url": "service/datenschutz"
          },
          {
            "label": "legalNotice",
            "url": "service/impressum"
          }
        ]
      },
      {
        "headline": "forPartners",
        "id": "partner",
        "items": [
          {
            "label": "becomeMediaPartner",
            "url": "service/partner",
            "masked": false
          },
          {
            "label": "advertisement",
            "url": "service/werbung",
            "masked": false
          },
          {
            "label": "becomePartnerHotel",
            "url": "https://www.invia.de/hotelpartner/",
            "masked": false
          },
          {
            "label": "Nachhaltigkeit",
            "url": "https://www.ab-in-den-urlaub.de/magazin/sustainability-lp/",
            "masked": false
          }
        ]
      }
    ],
    "socialLinks": [
      {
        "label": "facebook",
        "url": "https://www.facebook.com/abindenurlaub.de",
        "masked": false
      },
      {
        "label": "instagram",
        "url": "https://www.instagram.com/abindenurlaub",
        "masked": false
      },
      {
        "label": "pinterest",
        "url": "https://www.pinterest.de/abindenurlaubde",
        "masked": false
      },
      {
        "label": "youtube",
        "url": "https://www.youtube.com/user/abindenurlaubde",
        "masked": false
      },
      {
        "label": "tiktok",
        "url": "https://www.tiktok.com/@abindenurlaub",
        "masked": true
      },
      {
        "label": "whatsapp",
        "url": "https://whatsapp.com/channel/0029VaYOUSv05MUkwIfVuS2Y",
        "masked": true
      }
    ]
  },
  "filters": {
    "price": {
      "ranges": [
        {
          "minValue": 50000,
          "maxValue": 600000,
          "step": 50000
        }
      ],
      "priceMinEnabled": false,
      "enabledWithMultiroom": true
    },
    "transfer": {
      "options": [
        [
          "direct_flight",
          "direct_flight"
        ],
        [
          "hotel_transfer",
          "IT14-HTR"
        ],
        [
          "train_to_the_airport",
          "IT14-RAFL"
        ]
      ]
    },
    "departureTime": {
      "enabled": true
    },
    "returnTime": {
      "enabled": true
    },
    "popular": {
      "default": [
        {
          "id": "boardType",
          "value": "IT06-AI",
          "type": "multi"
        },
        {
          "id": "pool",
          "value": "IT03-POOL#OUT",
          "type": "multi"
        },
        {
          "id": "beach",
          "value": "IT03-BEA#DIR",
          "type": "multi"
        },
        {
          "id": "facilities",
          "value": "IT03-HOT#INTE",
          "type": "multi"
        },
        {
          "id": "roomAttributes",
          "value": "IT13-SEVI",
          "type": "multi"
        },
        {
          "id": "flightTransfer",
          "value": "direct_flight",
          "type": "multi"
        },
        {
          "id": "flightTransfer",
          "value": "IT14-HTR",
          "type": "multi"
        },
        {
          "id": "category",
          "value": "4",
          "type": "single"
        },
        {
          "id": "roomType",
          "value": "IT04-SUI",
          "type": "multi"
        },
        {
          "id": "hotelType",
          "value": "IT03-TYPE#ADU",
          "type": "multi"
        }
      ],
      "withChildren": [
        {
          "id": "boardType",
          "value": "IT06-AI",
          "type": "multi"
        },
        {
          "id": "children",
          "value": "IT03-CHI#WSLI",
          "type": "multi"
        },
        {
          "id": "beach",
          "value": "IT03-BEA#DIR",
          "type": "multi"
        },
        {
          "id": "facilities",
          "value": "IT03-HOT#INTE",
          "type": "multi"
        },
        {
          "id": "pool",
          "value": "IT03-POOL#OUT",
          "type": "multi"
        },
        {
          "id": "roomType",
          "value": "IT04-FA",
          "type": "multi"
        },
        {
          "id": "children",
          "value": "IT03-CHI#ANI",
          "type": "multi"
        },
        {
          "id": "flightTransfer",
          "value": "direct_flight",
          "type": "multi"
        },
        {
          "id": "flightTransfer",
          "value": "IT14-HTR",
          "type": "multi"
        },
        {
          "id": "hotelType",
          "value": "IT03-TYPE#FAM",
          "type": "multi"
        },
        {
          "id": "category",
          "value": "4",
          "type": "single"
        }
      ]
    },
    "category": {
      "showTooltip": true
    },
    "distances": {
      "showNewFeatureBadge": true
    }
  },
  "durationOptionsPackageNew": {
    "options": [
      {
        "min": 0,
        "max": 0,
        "id": "exact"
      },
      {
        "min": 8,
        "max": 8,
        "id": "9_days"
      },
      {
        "min": 9,
        "max": 9,
        "id": "10_days"
      },
      {
        "min": 10,
        "max": 10,
        "id": "11_days"
      },
      {
        "min": 11,
        "max": 11,
        "id": "12_days"
      },
      {
        "min": 7,
        "max": 7,
        "id": "1_week"
      },
      {
        "min": 14,
        "max": 14,
        "id": "2_weeks"
      },
      {
        "min": 21,
        "max": 21,
        "id": "3_weeks"
      },
      {
        "min": 28,
        "max": 28,
        "id": "4_weeks"
      }
    ],
    "maxDuration": 56
  },
  "durationOptionsOwnArrivalNew": {
    "options": [
      {
        "min": 0,
        "max": 0,
        "id": "exact"
      },
      {
        "min": 2,
        "max": 2,
        "id": "3_days"
      },
      {
        "min": 4,
        "max": 4,
        "id": "5_days"
      },
      {
        "min": 5,
        "max": 5,
        "id": "6_days"
      },
      {
        "min": 7,
        "max": 7,
        "id": "1_week"
      },
      {
        "min": 14,
        "max": 14,
        "id": "2_weeks"
      },
      {
        "min": 21,
        "max": 21,
        "id": "3_weeks"
      },
      {
        "min": 28,
        "max": 28,
        "id": "4_weeks"
      }
    ],
    "maxDuration": 56
  },
  "durationOptions": {
    "packageTour": [
      {
        "options": [
          {
            "value": {
              "min": 0,
              "max": 0
            }
          },
          {
            "value": {
              "min": 7,
              "max": 7
            }
          },
          {
            "value": {
              "min": 14,
              "max": 14
            }
          },
          {
            "value": {
              "min": 21,
              "max": 21
            }
          },
          {
            "value": {
              "min": 28,
              "max": 28
            }
          }
        ]
      },
      {
        "options": [
          {
            "value": {
              "min": 2,
              "max": 6
            }
          },
          {
            "value": {
              "min": 4,
              "max": 7
            }
          },
          {
            "value": {
              "min": 6,
              "max": 13
            }
          },
          {
            "value": {
              "min": 8,
              "max": 11
            }
          },
          {
            "value": {
              "min": 13,
              "max": 20
            }
          }
        ]
      },
      {
        "options": [
          {
            "value": {
              "min": 6,
              "max": 6
            }
          },
          {
            "value": {
              "min": 7,
              "max": 7,
              "exact": true
            }
          },
          {
            "value": {
              "min": 8,
              "max": 8
            }
          },
          {
            "value": {
              "min": 9,
              "max": 9
            }
          },
          {
            "value": {
              "min": 10,
              "max": 10
            }
          },
          {
            "value": {
              "min": 11,
              "max": 11
            }
          },
          {
            "value": {
              "min": 12,
              "max": 12
            }
          },
          {
            "value": {
              "min": 13,
              "max": 13,
              "exact": true
            }
          },
          {
            "value": {
              "min": 15,
              "max": 15
            }
          },
          {
            "value": {
              "min": 16,
              "max": 16
            }
          },
          {
            "value": {
              "min": 17,
              "max": 17
            }
          },
          {
            "value": {
              "min": 18,
              "max": 18
            }
          },
          {
            "value": {
              "min": 19,
              "max": 19
            }
          },
          {
            "value": {
              "min": 20,
              "max": 20
            }
          }
        ]
      }
    ],
    "ownArrival": [
      {
        "options": [
          {
            "value": {
              "min": 0,
              "max": 0
            }
          },
          {
            "value": {
              "min": 7,
              "max": 7
            }
          },
          {
            "value": {
              "min": 14,
              "max": 14
            }
          },
          {
            "value": {
              "min": 21,
              "max": 21
            }
          },
          {
            "value": {
              "min": 28,
              "max": 28
            }
          }
        ]
      },
      {
        "options": [
          {
            "value": {
              "min": 2,
              "max": 6
            }
          },
          {
            "value": {
              "min": 4,
              "max": 7
            }
          },
          {
            "value": {
              "min": 6,
              "max": 13
            }
          },
          {
            "value": {
              "min": 8,
              "max": 11
            }
          },
          {
            "value": {
              "min": 13,
              "max": 20
            }
          }
        ]
      },
      {
        "options": [
          {
            "value": {
              "min": 6,
              "max": 6
            }
          },
          {
            "value": {
              "min": 7,
              "max": 7,
              "exact": true
            }
          },
          {
            "value": {
              "min": 8,
              "max": 8
            }
          },
          {
            "value": {
              "min": 9,
              "max": 9
            }
          },
          {
            "value": {
              "min": 10,
              "max": 10
            }
          },
          {
            "value": {
              "min": 11,
              "max": 11
            }
          },
          {
            "value": {
              "min": 12,
              "max": 12
            }
          },
          {
            "value": {
              "min": 13,
              "max": 13,
              "exact": true
            }
          },
          {
            "value": {
              "min": 15,
              "max": 15
            }
          },
          {
            "value": {
              "min": 16,
              "max": 16
            }
          },
          {
            "value": {
              "min": 17,
              "max": 17
            }
          },
          {
            "value": {
              "min": 18,
              "max": 18
            }
          },
          {
            "value": {
              "min": 19,
              "max": 19
            }
          },
          {
            "value": {
              "min": 20,
              "max": 20
            }
          }
        ]
      }
    ]
  },
  "cpcAds": {
    "placementKeys": {
      "cpcAdHotelsFooter": {
        "mobile": "955aadd96c03ab94e7eb67a2d662851b",
        "tablet": "f052c5e2ddbbf281d8cf68dde69eaec2",
        "desktop": "fe0e28aca1431e6a55fcaf1c75c52cf7"
      },
      "cpcAdHotelsSidebar": {
        "mobile": "d1454db019d0827e6a766da789eb9e35",
        "tablet": "d1454db019d0827e6a766da789eb9e35",
        "desktop": "d1454db019d0827e6a766da789eb9e35"
      },
      "cpcAdOffersFooter": {
        "mobile": "1ee8bd29eb269a28220bd95cdf8e2c39",
        "tablet": "c2d7676af43f73b5d9fa312efb29cf68",
        "desktop": "97e279f2f6422b72f22f9c96da69af4b"
      },
      "cpcAdOffersSidebar": {
        "mobile": "da00994c8114cbe2bbf01aa0fdd1277f",
        "tablet": "da00994c8114cbe2bbf01aa0fdd1277f",
        "desktop": "da00994c8114cbe2bbf01aa0fdd1277f"
      }
    }
  },
  "bloomreach": {
    "target": "https://msrmnt.ab-in-den-urlaub.at",
    "token": "fe80ab10-f00d-11ed-9452-7e645c4b2c97",
    "experimental": {
      "non_personalized_weblayers": true
    },
    "track": {
      "visits": false,
      "google_analytics": false
    },
    "ping": {
      "enabled": true,
      "interval": 900
    },
    "service_worker_path": "/service-worker.js"
  },
  "airports": [
    {
      "airports": [
        {
          "code": "GRZ",
          "nearby": [
            {
              "code": "VIE",
              "distance": "202"
            },
            {
              "code": "KLU",
              "distance": "127"
            },
            {
              "code": "LNZ",
              "distance": "252"
            }
          ]
        },
        {
          "code": "INN",
          "nearby": [
            {
              "code": "MUC",
              "distance": "179"
            },
            {
              "code": "SZG",
              "distance": "183"
            },
            {
              "code": "FMM",
              "distance": "183"
            }
          ]
        },
        {
          "code": "KLU",
          "nearby": [
            {
              "code": "GRZ",
              "distance": "127"
            },
            {
              "code": "SZG",
              "distance": "224"
            },
            {
              "code": "LNZ",
              "distance": "249"
            }
          ]
        },
        {
          "code": "LNZ",
          "nearby": [
            {
              "code": "VIE",
              "distance": "211"
            },
            {
              "code": "SZG",
              "distance": "132"
            },
            {
              "code": "MUC",
              "distance": "219"
            }
          ]
        },
        {
          "code": "SZG",
          "nearby": [
            {
              "code": "INN",
              "distance": "183"
            },
            {
              "code": "KLU",
              "distance": "224"
            },
            {
              "code": "LNZ",
              "distance": "132"
            }
          ]
        },
        {
          "code": "VIE",
          "nearby": [
            {
              "code": "GRZ",
              "distance": "202"
            },
            {
              "code": "LNZ",
              "distance": "211"
            },
            {
              "code": "BTS",
              "distance": "75"
            }
          ]
        }
      ],
      "children": [],
      "code": "at",
      "default": true
    },
    {
      "children": [
        {
          "airports": [
            {
              "code": "BRE",
              "nearby": [
                {
                  "code": "HAM",
                  "distance": "130"
                },
                {
                  "code": "HAJ",
                  "distance": "113"
                },
                {
                  "code": "LBC",
                  "distance": "186"
                }
              ]
            },
            {
              "code": "HAM",
              "nearby": [
                {
                  "code": "BRE",
                  "distance": "130"
                },
                {
                  "code": "HAJ",
                  "distance": "162 "
                },
                {
                  "code": "LBC",
                  "distance": "70"
                }
              ]
            },
            {
              "code": "HAJ",
              "nearby": [
                {
                  "code": "BRE",
                  "distance": "113"
                },
                {
                  "code": "HAM",
                  "distance": "162"
                },
                {
                  "code": "PAD",
                  "distance": "160"
                }
              ]
            },
            {
              "code": "HDF",
              "nearby": [
                {
                  "code": "RLG",
                  "distance": "151"
                },
                {
                  "code": "BER",
                  "distance": "266"
                },
                {
                  "code": "LBC",
                  "distance": "271"
                }
              ]
            },
            {
              "code": "LBC",
              "nearby": [
                {
                  "code": "BRE",
                  "distance": "186"
                },
                {
                  "code": "HAM",
                  "distance": "70"
                },
                {
                  "code": "HAJ",
                  "distance": "207"
                }
              ]
            },
            {
              "code": "RLG",
              "nearby": [
                {
                  "code": "LBC",
                  "distance": "135"
                },
                {
                  "code": "BER",
                  "distance": "226"
                },
                {
                  "code": "HDF",
                  "distance": "151"
                }
              ]
            },
            {
              "code": "GWT",
              "nearby": [
                {
                  "code": "BLL",
                  "distance": "131"
                },
                {
                  "code": "HAM",
                  "distance": "228"
                },
                {
                  "code": "LBC",
                  "distance": "249"
                }
              ]
            }
          ],
          "code": "germanyNorth",
          "default": false
        },
        {
          "airports": [
            {
              "code": "FDH",
              "nearby": [
                {
                  "code": "FMM",
                  "distance": "92"
                },
                {
                  "code": "MUC",
                  "distance": "230"
                },
                {
                  "code": "STR",
                  "distance": "180"
                }
              ]
            },
            {
              "code": "FKB",
              "nearby": [
                {
                  "code": "SCN",
                  "distance": "128"
                },
                {
                  "code": "STR",
                  "distance": "109"
                },
                {
                  "code": "FRA",
                  "distance": "168"
                }
              ]
            },
            {
              "code": "FMM",
              "nearby": [
                {
                  "code": "FDH",
                  "distance": "92"
                },
                {
                  "code": "ZRH",
                  "distance": "200"
                },
                {
                  "code": "MUC",
                  "distance": "140"
                }
              ]
            },
            {
              "code": "MUC",
              "nearby": [
                {
                  "code": "FMM",
                  "distance": "140"
                },
                {
                  "code": "NUE",
                  "distance": "166"
                }
              ]
            },
            {
              "code": "NUE",
              "nearby": [
                {
                  "code": "FRA",
                  "distance": "225"
                },
                {
                  "code": "MUC",
                  "distance": "166"
                },
                {
                  "code": "FMM",
                  "distance": "255"
                }
              ]
            },
            {
              "code": "STR",
              "nearby": [
                {
                  "code": "FDH",
                  "distance": "180"
                },
                {
                  "code": "FKB",
                  "distance": "110"
                },
                {
                  "code": "FMM",
                  "distance": "138"
                }
              ]
            }
          ],
          "code": "germanySouth",
          "default": false
        },
        {
          "airports": [
            {
              "code": "DTM",
              "nearby": [
                {
                  "code": "PAD",
                  "distance": "74"
                },
                {
                  "code": "DUS",
                  "distance": "85"
                },
                {
                  "code": "FRA",
                  "distance": "231"
                }
              ]
            },
            {
              "code": "DUS",
              "nearby": [
                {
                  "code": "DTM",
                  "distance": "85"
                },
                {
                  "code": "NRN",
                  "distance": "72"
                },
                {
                  "code": "FRA",
                  "distance": "225"
                }
              ]
            },
            {
              "code": "HHN",
              "nearby": [
                {
                  "code": "FRA",
                  "distance": "111"
                },
                {
                  "code": "LUX",
                  "distance": "110"
                },
                {
                  "code": "ZQW",
                  "distance": "127"
                }
              ]
            },
            {
              "code": "FRA",
              "nearby": [
                {
                  "code": "HHN",
                  "distance": "110"
                },
                {
                  "code": "NUE",
                  "distance": "225"
                },
                {
                  "code": "KSF",
                  "distance": "208"
                }
              ]
            },
            {
              "code": "KSF",
              "nearby": [
                {
                  "code": "DTM",
                  "distance": "136"
                },
                {
                  "code": "HAJ",
                  "distance": "183"
                },
                {
                  "code": "ERF",
                  "distance": "161"
                }
              ]
            },
            {
              "code": "CGN",
              "nearby": [
                {
                  "code": "DTM",
                  "distance": "103"
                },
                {
                  "code": "DUS",
                  "distance": "63"
                },
                {
                  "code": "HHN",
                  "distance": "156"
                }
              ]
            },
            {
              "code": "FMO",
              "nearby": [
                {
                  "code": "BRE",
                  "distance": "148"
                },
                {
                  "code": "HAJ",
                  "distance": "170"
                },
                {
                  "code": "DUS",
                  "distance": "141"
                }
              ]
            },
            {
              "code": "PAD",
              "nearby": [
                {
                  "code": "DTM",
                  "distance": "74"
                },
                {
                  "code": "HAJ",
                  "distance": "160"
                },
                {
                  "code": "FRA",
                  "distance": "229"
                }
              ]
            },
            {
              "code": "SCN",
              "nearby": [
                {
                  "code": "FKB",
                  "distance": "128"
                },
                {
                  "code": "STR",
                  "distance": "206"
                },
                {
                  "code": "HHN",
                  "distance": "125"
                }
              ]
            },
            {
              "code": "ZQW",
              "nearby": [
                {
                  "code": "HHN",
                  "distance": "127"
                },
                {
                  "code": "LUX",
                  "distance": "145"
                },
                {
                  "code": "SCN",
                  "distance": "32"
                }
              ]
            }
          ],
          "code": "germanyWest",
          "default": false
        },
        {
          "airports": [
            {
              "code": "BER",
              "nearby": [
                {
                  "code": "LEJ",
                  "distance": "177"
                },
                {
                  "code": "DRS",
                  "distance": "168"
                },
                {
                  "code": "HDF",
                  "distance": "266"
                }
              ]
            },
            {
              "code": "DRS",
              "nearby": [
                {
                  "code": "LEJ",
                  "distance": "127"
                },
                {
                  "code": "BER",
                  "distance": "168"
                },
                {
                  "code": "PRG",
                  "distance": "175"
                }
              ]
            },
            {
              "code": "ERF",
              "nearby": [
                {
                  "code": "LEJ",
                  "distance": "156"
                },
                {
                  "code": "KSF",
                  "distance": "161"
                },
                {
                  "code": "FRA",
                  "distance": "257"
                }
              ]
            },
            {
              "code": "LEJ",
              "nearby": [
                {
                  "code": "DRS",
                  "distance": "127"
                },
                {
                  "code": "BER",
                  "distance": "177"
                },
                {
                  "code": "ERF",
                  "distance": "156"
                },
                {
                  "code": "LEJ",
                  "distance": "0"
                }
              ]
            }
          ],
          "code": "germanyEast",
          "default": false
        }
      ],
      "code": "de",
      "default": false
    },
    {
      "airports": [
        {
          "code": "BSL",
          "nearby": [
            {
              "code": "BRN",
              "distance": "116"
            },
            {
              "code": "FKB",
              "distance": "168"
            },
            {
              "code": "ZRH",
              "distance": "96"
            }
          ]
        },
        {
          "code": "BRN",
          "nearby": [
            {
              "code": "BSL",
              "distance": "116"
            },
            {
              "code": "GVA",
              "distance": "161"
            },
            {
              "code": "ZRH",
              "distance": "140"
            }
          ]
        },
        {
          "code": "GVA",
          "nearby": [
            {
              "code": "ZRH",
              "distance": "282"
            },
            {
              "code": "BRN",
              "distance": "161"
            },
            {
              "code": "BSL",
              "distance": "251"
            }
          ]
        },
        {
          "code": "ZRH",
          "nearby": [
            {
              "code": "BSL",
              "distance": "96"
            },
            {
              "code": "BRN",
              "distance": "140"
            },
            {
              "code": "GVA",
              "distance": "282"
            }
          ]
        }
      ],
      "children": [],
      "code": "ch",
      "default": false
    },
    {
      "airports": [
        {
          "code": "AMS",
          "nearby": []
        },
        {
          "code": "BLL",
          "nearby": []
        },
        {
          "code": "BTS",
          "nearby": []
        },
        {
          "code": "WRO",
          "nearby": []
        },
        {
          "code": "BRQ",
          "nearby": []
        },
        {
          "code": "BRU",
          "nearby": []
        },
        {
          "code": "BUD",
          "nearby": []
        },
        {
          "code": "CRL",
          "nearby": []
        },
        {
          "code": "EIN",
          "nearby": []
        },
        {
          "code": "ENS",
          "nearby": []
        },
        {
          "code": "GRQ",
          "nearby": []
        },
        {
          "code": "KRK",
          "nearby": []
        },
        {
          "code": "LGG",
          "nearby": []
        },
        {
          "code": "LUX",
          "nearby": []
        },
        {
          "code": "MST",
          "nearby": []
        },
        {
          "code": "OSR",
          "nearby": []
        },
        {
          "code": "PRG",
          "nearby": []
        },
        {
          "code": "SXB",
          "nearby": []
        },
        {
          "code": "WAW",
          "nearby": []
        }
      ],
      "children": [],
      "code": "eu",
      "default": false
    }
  ],
  "adition": {
    "slots": {
      "DSK_Urlaubsreisen_Buchungsstrecke_MR_300x250": {
        "id": "DSK_Urlaubsreisen_Buchungsstrecke_MR_300x250",
        "contentUnitId": 3527286,
        "width": 300,
        "height": 250
      },
      "DSK_Urlaubsreisen_Buchungsstrecke_WS_300x600": {
        "id": "DSK_Urlaubsreisen_Buchungsstrecke_WS_300x600",
        "contentUnitId": 3340787,
        "width": 300,
        "height": 600
      },
      "DSK_Urlaubsreisen_Buchungsstrecke_WS_160x600": {
        "id": "DSK_Urlaubsreisen_Buchungsstrecke_WS_160x600",
        "contentUnitId": 3527284,
        "width": 160,
        "height": 600
      },
      "TBL_Urlaubsreisen_Buchungsstrecke_SB_mitte_728x90": {
        "id": "TBL_Urlaubsreisen_Buchungsstrecke_SB_mitte_728x90",
        "contentUnitId": 3527289,
        "width": 728,
        "height": 90
      },
      "SMP_Urlaubsreisen_Buchungsstrecke_flexMR_mitte_300x250": {
        "id": "SMP_Urlaubsreisen_Buchungsstrecke_flexMR_mitte_300x250",
        "contentUnitId": 3527295,
        "width": 300,
        "height": 250
      }
    }
  }
} as const;